module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 mx-auto login-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', [_c('h1', [_c('a', {
    attrs: {
      "href": "https://royalpag.com"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), (!_vm.solicitacaoEnviada) ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Não recebeu o e-mail de verificação?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "well top4",
    staticStyle: {
      "text-align-last": "center"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.solicitarNovoEmail.apply(null, arguments)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "sign-in",
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Já é um membro?  "), _c('router-link', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "to": "/auth/login"
    }
  }, [_vm._v("Entrar")])], 1)])])])])]) : _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              E-mail enviado com sucesso!\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify text-default-gray",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto"
    }
  }, [_vm._v("Cofira sua caixa de e-mail. Não esqueça de verifcar a caixa de spam.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "reset",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.voltar.apply(null, arguments)
      }
    }
  })])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b', {
    staticClass: "form-group justify-content-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block mb-3 center-align",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding-left": "35px",
      "position": "absolute",
      "padding-top": "3px"
    }
  }, [_vm._v("Reenviar e-mail")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-649bc2fa","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/email.vue
// module id = BxPN
// module chunks = 36